<template>
    <v-card flat tile>
        <AddCategoryDialog :show="showAddDialog" @close="showAddDialog = false" @catCreated="catCreated" :newCategory="newCategory" :presetParentId="presetParentId"></AddCategoryDialog>
        <DeleteCategoryDialog :show="showDeleteDialog" :selectedDeleteItem="selectedDeleteItem" @catDeleted="catDeleted" @close="showDeleteDialog = false"></DeleteCategoryDialog>

        <div style="position: relative">
            <div style="position: absolute; z-index: 5; top: -38px; right: 16px">
                <!-- <v-chip outlined small class="mr-2 pl-4 pr-1">
                        {{ selectedRows.length }} SELECTED
                        <v-btn class="mx-1" x-small icon @click="selectedRows = []"><v-icon x-small>mdi-close</v-icon></v-btn>
                    </v-chip> -->
                <v-tooltip top :disabled="!test_set">
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                            <v-btn elevation="0" :disabled="$store.state.monitoring_suite_group.id == 2 || test_set" color="primary" outlined rounded small @click="setAddCategoryDialog()">
                                <v-icon class="mr-1" small>mdi-plus</v-icon>category</v-btn
                            >
                        </span>
                    </template>
                    <span>Disabled on Example-Set</span>
                </v-tooltip>
                <!-- <v-btn elevation="0" outlined rounded color="error" small @click="deleteDialog = true"> <v-icon class="mr-1" small>mdi-delete</v-icon> delete</v-btn> -->
            </div>
        </div>
        <v-card flat class="px-4 pt-2 pb-1">
            <v-row dense>
                <v-col cols="12" md="3" sm="6">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                                <v-select
                                    v-model="filters.levels"
                                    :items="availableLevelsForSelect"
                                    item-text="text"
                                    item-value="value"
                                    rounded
                                    filled
                                    label="Level"
                                    multiple
                                    hide-details
                                    chips
                                    clearable
                                    hide-selected
                                    dense
                                    :menu-props="{ maxHeight: 300 }" />
                            </div>
                        </template>
                        <span>Filter categories by hierarchy level (1 = top level).</span>
                    </v-tooltip>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                                <v-select
                                    v-model="filters.trendMonths"
                                    :items="availableTrendMonths"
                                    rounded
                                    filled
                                    label="Focus month"
                                    multiple
                                    hide-details
                                    chips
                                    clearable
                                    hide-selected
                                    dense
                                    :menu-props="{ maxHeight: 300 }" />
                            </div>
                        </template>
                        <span>Choose the reference month that defines the 12M window for trend and header metrics.</span>
                    </v-tooltip>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                                <v-select
                                    v-model="filters.peakMonths"
                                    :items="availablePeakMonths"
                                    rounded
                                    filled
                                    label="Peak month"
                                    multiple
                                    hide-details
                                    chips
                                    clearable
                                    hide-selected
                                    dense
                                    :menu-props="{ maxHeight: 300 }" />
                            </div>
                        </template>
                        <span>Show only categories whose peak month (last 12M) matches the selected month(s).</span>
                    </v-tooltip>
                </v-col>

                <v-col cols="12" md="1" sm="6" class="d-flex align-center justify-end">
                    <v-chip v-if="activeFilterCount > 0" outlined color="primary" class="qchip" small label> {{ activeFilterCount }} Filter aktiv </v-chip>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                    <v-switch v-model="showMonthlyColumns" class="mr-auto mt-2" inset dense hide-details :label="showMonthlyColumns ? 'hide monthly searches' : 'show monthly searches'" />
                    <!-- <v-switch v-model="showHeatmap" class="mt-2" inset dense hide-details :disabled="!showMonthlyColumns" label="heatmap" /> -->
                </v-col>
            </v-row>

            <!-- Aktive Filterchips -->
            <v-row dense v-if="activeFilterCount > 0">
                <v-col cols="12">
                    <div class="d-flex flex-wrap">
                        <v-chip v-for="lvl in filters.levels" :key="'lvl-' + lvl" class="mr-2 mb-2" small outlined color="primary" close @click:close="removeFilter('levels', lvl)">
                            Level: {{ Number(lvl) + 1 }}
                        </v-chip>

                        <v-chip v-for="m in filters.trendMonths" :key="'trend-' + m" class="mr-2 mb-2" small outlined color="primary" close @click:close="removeFilter('trendMonths', m)">
                            Trend: {{ m }}
                        </v-chip>

                        <v-chip v-for="m in filters.peakMonths" :key="'peak-' + m" class="mr-2 mb-2" small outlined color="primary" close @click:close="removeFilter('peakMonths', m)">
                            Peak: {{ m }}
                        </v-chip>
                    </div>
                </v-col>
            </v-row>
        </v-card>
        <!-- @click:row="switchCat" -->

        <v-data-table
            id="monitoringCatTable"
            @click:row="switchCat"
            :headers="headers"
            :items="categories"
            :loading="loading"
            :items-per-page.sync="itemsPerPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            item-class="row-pointer"
            fixed-header
            height="70vh"
            class="row-pointer">
            <template v-for="(header_entry, index) in headers" v-slot:[`header.${header_entry.value}`]="{ header }">
                <span>
                    <span v-bind:style="{ width: header.width }">
                        <v-tooltip max-width="250" color="" top :disabled="header.tooltip ? false : true">
                            <template v-slot:activator="{ on }">
                                <span v-on="on" style="white-space: nowrap; text-transform: uppercase; font-weight: 500">
                                    {{ header.text }}
                                    <v-icon class="questionIcon" v-if="header.tooltip" x-small>mdi-help-circle-outline</v-icon>
                                </span>
                            </template>
                            <span>
                                <v-row no-gutters>
                                    <div cols="12"><v-icon color="white">mdi-help-circle-outline</v-icon></div>
                                </v-row>
                                {{ header.tooltip }}
                            </span>
                        </v-tooltip>
                    </span>
                </span>
            </template>
            <template v-slot:item.category="{ item }">
                <span class="rtd my-5">{{ getCategoryLabel(item) }}</span>
            </template>
            <template v-slot:item.keyword_count="{ item }">
                <v-chip outlined class="qchip my-3" color="primary" style="">
                    {{ $helpers.formatNumber(item.keyword_count) }}
                </v-chip>
            </template>

            <!-- NEU: Amazon search volume -->
            <template v-slot:item.amazon_search_volume_total="{ item }">
                <v-chip outlined class="qchip" color="primary">
                    {{ item.amazon_search_volume_total ? $helpers.formatNumber(item.amazon_search_volume_total) : "no data" }}
                </v-chip>
            </template>
            <!-- Internal search volume inkl. Veränderung zum Vorjahres-Import -->
            <template v-slot:item.internal_search_volume_total="{ item }">
                <span class="d-inline-flex align-center">
                    <v-chip outlined class="qchip" color="primary">
                        {{ item.internal_search_volume_total ? $helpers.formatNumber(item.internal_search_volume_total) : "no data" }}
                    </v-chip>
                    <span v-if="internalSvChangePercent(item) !== null" class="internal-sv-change ml-1">
                        <v-icon size="14" v-if="internalSvChangePercent(item) > 0" color="success">mdi-menu-up</v-icon>
                        <v-icon size="14" v-else-if="internalSvChangePercent(item) < 0" color="error">mdi-menu-down</v-icon>
                        <span v-else class="internal-sv-change__dash">–</span>
                        <span class="internal-sv-change__value">{{ Math.abs(internalSvChangePercent(item)).toFixed(1) }}%</span>
                    </span>
                </span>
            </template>
            <!-- Visibility for each Competitor by Category -->
            <template v-for="competitor in selectedCompetitors" v-slot:[`item.visibility_${competitor.domain}.value`]="{ item }">
                <div v-bind="(visibData = getCompVisib(item, competitor.domain))">
                    <v-row style="flex-wrap: nowrap !important" class="mx-5">
                        <!-- <div class="d-flex ml-auto my-auto mr-1" v-if="visibData.change != null">
                            <v-icon small class="my-auto">{{ visibData.change ? (visibData.change < 0 ? "mdi-arrow-down" : "mdi-arrow-up") : "mdi-arrow-right" }}</v-icon>
                            <span class="rankingchange my-auto">{{ visibData.change }}</span>
                        </div>
                        <v-chip outlined :class="visibData.change == null ? 'qchip ml-auto' : 'qchip'">
                            {{ visibData.value }}
                        </v-chip> -->
                        <span class="ml-auto my-auto"> {{ $helpers.formatNumber(visibData.value) }}</span>
                        <v-chip class="ml-2 qchip" :color="visibData.change == 0 ? '' : visibData.change < 0 ? 'red' : 'green'" outlined v-if="visibData">
                            <span v-if="!visibData.status">
                                <v-icon v-if="visibData.change !== 0" class="mr-1" small :color="visibData.change < 0 ? 'red' : 'green'">{{
                                    visibData.change < 0 ? "mdi-arrow-down" : "mdi-arrow-up"
                                }}</v-icon>
                                <v-icon v-else class="mr-1" small color="grey darken-2">mdi-arrow-right</v-icon>
                                <span class="my-auto">{{ visibData.change.toFixed(2) }}%</span>
                            </span>

                            <span v-else>{{ visibData.status }}</span>
                        </v-chip>
                    </v-row>
                </div>
            </template>
            <template v-slot:item.actions="{ item }">
                <div>
                    <v-menu offset-y rounded="lg" color="primary" transition="slide-y-transition" bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn :disabled="$store.state.monitoring_suite_group.id == 2" v-on="on" icon class="ml-auto">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list rounded dense>
                            <v-tooltip top :disabled="!test_set">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <v-list-item :disabled="test_set" @click="setAddCategoryDialog(item)">
                                            <v-icon small class="mr-2">mdi-plus-circle</v-icon><v-list-item-title>SUB-CATEGORY</v-list-item-title>
                                        </v-list-item>
                                    </span>
                                </template>
                                <span>Disabled on Example-Set</span>
                            </v-tooltip>
                            <v-tooltip top :disabled="!test_set">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <v-list-item :disabled="test_set" @click="$emit('showAddKwDialog', item)">
                                            <v-icon small class="mr-2">mdi-cloud-upload</v-icon><v-list-item-title>KEYWORDS</v-list-item-title>
                                        </v-list-item>
                                    </span>
                                </template>
                                <span>Disabled on Example-Set</span>
                            </v-tooltip>
                            <v-tooltip top :disabled="!test_set">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <v-list-item
                                            :disabled="test_set"
                                            @click="
                                                selectedDeleteItem = item
                                                showDeleteDialog = true
                                            ">
                                            <v-icon small class="mr-2">mdi-delete</v-icon><v-list-item-title>DELETE</v-list-item-title>
                                        </v-list-item>
                                    </span>
                                </template>
                                <span>Disabled on Example-Set</span>
                            </v-tooltip>
                        </v-list>
                    </v-menu>
                </div>
            </template>
            <template v-slot:no-data>
                <div class="my-10">
                    <span v-if="category_id">
                        <p>No child categories found...</p>
                        <v-btn @click="$emit('clearCategoryId')" text small color="primary"> <v-icon small class="mr-1">mdi-close</v-icon> clear selection</v-btn>
                    </span>
                    <span v-else>
                        <v-row class="mt-5">
                            <v-col>
                                <v-card color="primary" max-width="600px" class="mx-auto rounded_card quaroshadow">
                                    <v-card-text>
                                        <v-row>
                                            <v-col md="8" sm="8" class="white--text" style="text-align: left">
                                                <h2 class="my-2">
                                                    No data!
                                                    <!-- <v-chip x-small color="red" class="white--text ml-1 px-2"> new feature</v-chip> -->
                                                </h2>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </span>
                </div>
            </template>
            <template v-slot:item.search_trend="{ item }">
                <v-chip outlined class="qchip" :color="item.search_trend > 0 ? 'green darken-2' : item.search_trend < 0 ? 'red darken-2' : 'grey darken-2'">
                    <v-icon small class="mr-1" :color="item.search_trend > 0 ? 'green darken-2' : item.search_trend < 0 ? 'red darken-2' : 'grey darken-2-'">
                        {{ item.search_trend > 0 ? "mdi-arrow-up" : item.search_trend < 0 ? "mdi-arrow-down" : "mdi-arrow-right" }}
                    </v-icon>
                    {{ item.search_trend !== null && item.search_trend !== undefined ? item.search_trend.toFixed(2) + "%" : "no data" }}
                </v-chip>
            </template>
            <template v-slot:item.movingavg_short="{ item }">
                <v-chip outlined class="qchip" color="primary">
                    <v-icon v-if="item.movingavg_short < 0" small color="red darken-2">mdi-arrow-down</v-icon>
                    <v-icon v-else small color="green darken-2">mdi-arrow-up</v-icon>
                    {{ item.movingavg_short ? item.movingavg_short.toFixed(2) : 0 }}%
                </v-chip>
            </template>
            <template v-slot:item.movingavg_long="{ item }">
                <v-chip outlined class="qchip" color="primary">
                    <v-icon v-if="item.movingavg_long < 0" small color="red darken-2">mdi-arrow-down</v-icon>
                    <v-icon v-else small color="green darken-2">mdi-arrow-up</v-icon>
                    {{ item.movingavg_long ? item.movingavg_long.toFixed(2) : 0 }}%
                </v-chip>
            </template>
            <template v-slot:item.avg_search_volume="{ item }">
                <v-chip outlined class="qchip" color="primary">
                    {{ item.avg_search_volume ? $helpers.formatNumber(item.avg_search_volume) : "no data" }}
                </v-chip>
            </template>
            <template v-slot:item.latest_12_month_search_volume="{ item }">
                <v-chip outlined class="qchip" color="primary">
                    {{ item.latest_12_month_search_volume ? $helpers.formatNumber(item.latest_12_month_search_volume) : "no data" }}
                </v-chip>
            </template>
            <template v-slot:item.prev_12_month_search_volume="{ item }">
                <v-chip outlined class="qchip" color="primary">
                    {{ item.prev_12_month_search_volume ? $helpers.formatNumber(item.prev_12_month_search_volume) : "no data" }}
                </v-chip>
            </template>
            <template v-slot:item.year_change_percent="{ item }">
                <v-chip outlined class="qchip" :color="item.year_change_percent > 0 ? 'green darken-2' : item.year_change_percent < 0 ? 'red darken-2' : 'grey darken-2'">
                    <v-icon class="mr-1" small :color="item.year_change_percent > 0 ? 'green darken-2' : item.year_change_percent < 0 ? 'red darken-2' : 'grey darken-2'">
                        {{ item.year_change_percent > 0 ? "mdi-arrow-up" : item.year_change_percent < 0 ? "mdi-arrow-down" : "mdi-arrow-right" }}
                    </v-icon>
                    {{ item.year_change_percent !== undefined && item.year_change_percent !== null ? item.year_change_percent.toFixed(2) + "%" : "no data" }}
                </v-chip>
            </template>
            <template v-slot:item.month_change_percent="{ item }">
                <v-chip outlined class="qchip" :color="item.month_change_percent > 0 ? 'green darken-2' : item.month_change_percent < 0 ? 'red darken-2' : 'grey darken-2'">
                    <v-icon class="mr-1" small :color="item.month_change_percent > 0 ? 'green darken-2' : item.month_change_percent < 0 ? 'red darken-2' : 'grey darken-2'">
                        {{ item.month_change_percent > 0 ? "mdi-arrow-up" : item.month_change_percent < 0 ? "mdi-arrow-down" : "mdi-arrow-right" }}
                    </v-icon>
                    {{ item.month_change_percent !== undefined && item.month_change_percent !== null ? item.month_change_percent.toFixed(2) + "%" : "no data" }}
                </v-chip>
            </template>
            <template v-slot:item.month_change_abs="{ item }">
                <v-chip outlined class="qchip" :color="item.month_change_abs > 0 ? 'green darken-2' : item.month_change_abs < 0 ? 'red darken-2' : 'grey darken-2'">
                    <v-icon class="mr-1" small :color="item.month_change_abs > 0 ? 'green darken-2' : item.month_change_abs < 0 ? 'red darken-2' : 'grey darken-2'">
                        {{ item.month_change_abs > 0 ? "mdi-arrow-up" : item.month_change_abs < 0 ? "mdi-arrow-down" : "mdi-arrow-right" }}
                    </v-icon>
                    {{ item.month_change_abs !== null && item.month_change_abs !== undefined ? $helpers.formatNumber(item.month_change_abs) : "no data" }}
                </v-chip>
            </template>

            <template v-slot:item.latestYearMonth="{ item }">
                <v-chip outlined class="qchip" color="primary">
                    {{ item.latestYearMonth ? $helpers.formatNumber(item.latestYearMonth) : "no data" }}
                </v-chip>
            </template>
            <template v-slot:item.lastYearMonth="{ item }">
                <v-chip outlined class="qchip" color="primary">
                    {{ item.lastYearMonth ? $helpers.formatNumber(item.lastYearMonth) : "no data" }}
                </v-chip>
            </template>
            <template v-slot:item.year_change_abs="{ item }">
                <v-chip outlined class="qchip" :color="item.year_change_abs > 0 ? 'green darken-2' : item.year_change_abs < 0 ? 'red darken-2' : 'grey darken-2'">
                    <v-icon class="mr-1" small :color="item.year_change_abs > 0 ? 'green darken-2' : item.year_change_abs < 0 ? 'red darken-2' : 'grey darken-2'">
                        {{ item.year_change_abs > 0 ? "mdi-arrow-up" : item.year_change_abs < 0 ? "mdi-arrow-down" : "mdi-arrow-right" }}
                    </v-icon>
                    {{ item.year_change_abs !== null && item.year_change_abs !== undefined ? $helpers.formatNumber(item.year_change_abs) : "no data" }}
                </v-chip>
            </template>
            <template v-slot:item.peakMonthLabel="{ item }">
                <v-chip outlined class="qchip" color="primary">
                    {{ item.peakMonthLabel || "no data" }}
                </v-chip>
            </template>

            <!-- Dynamische Monats-Spalten (letzte 12 Monate) -->
            <template v-for="col in monthlyHeaders" v-slot:[`item.${col.value}`]="{ item }">
                <span class="ml-auto heat-cell" :style="heatBgStyle(col.label, getMonthlyVolume(item, col.label))">
                    {{ getMonthlyVolume(item, col.label) !== null ? $helpers.formatNumber(getMonthlyVolume(item, col.label)) : "no data" }}
                </span>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import monitoringTaxonomy from "@/mixins/monitoringTaxonomy"
    import AddCategoryDialog from "./AddCategoryDialog"
    import DeleteCategoryDialog from "./DeleteCategoryDialog"

    export default {
        mixins: [monitoringTaxonomy],
        components: {
            AddCategoryDialog,
            DeleteCategoryDialog
        },
        props: {
            category_id: String,
            selectedDates: Array,
            selectedCompetitors: Array,
            search: String,
            exportData: Number,
            project_domain: String
        },
        data() {
            return {
                showMonthlyColumns: false,
                filters: {
                    levels: [],
                    trendMonths: [], // statt null: immer Array
                    peakMonths: []
                },
                monthOptions: {
                    trendMonths: [],
                    peakMonths: []
                },
                levelOptions: [], // NEU
                count: 0,
                loading: false,
                sortDesc: true,
                sortBy: "keyword_count",
                page: 1,
                itemsPerPage: 25,
                pagination: {},
                categories: [],
                showDeleteDialog: false,
                showAddDialog: false,
                newCategory: {
                    parent: null,
                    name: ""
                },
                selectedDeleteItem: null,
                presetParentId: "",
                showHeatmap: false,
                showAddCategoryDialog: false // FIX: wurde benutzt aber nicht definiert
            }
        },
        computed: {
            monthRefLatest() {
                if (this.trendContextMonth) return this.trendContextMonth
                const arr = this.allAvailableMonthsSorted
                return arr.length ? arr[arr.length - 1] : null
            },
            monthRefPrevYear() {
                return this.shiftMonthLabel(this.monthRefLatest, -12)
            },
            monthRefCurrent12Range() {
                if (!this.monthRefLatest) return null
                const start = this.shiftMonthLabel(this.monthRefLatest, -11)
                return start ? `${start} - ${this.monthRefLatest}` : null
            },
            monthRefPrevious12Range() {
                if (!this.monthRefLatest) return null
                const end = this.shiftMonthLabel(this.monthRefLatest, -12)
                const start = this.shiftMonthLabel(this.monthRefLatest, -23)
                return start && end ? `${start} - ${end}` : null
            },
            availableLevelsForSelect() {
                return (this.availableLevels || []).map((lvl) => ({
                    text: String(Number(lvl) + 1), // Anzeige +1
                    value: lvl // Modell/Backend: Original
                }))
            },
            monthStats() {
                const stats = {}
                for (const label of this.monthColumnLabels) {
                    let min = Infinity
                    let max = -Infinity
                    for (const cat of this.categories) {
                        const v = this.getMonthlyVolume(cat, label)
                        if (v !== null && v !== undefined) {
                            if (v < min) min = v
                            if (v > max) max = v
                        }
                    }
                    stats[label] = min === Infinity ? { min: null, max: null } : { min, max }
                }
                return stats
            },
            trendContextMonth() {
                return this.filters.trendMonths.length === 1 ? this.filters.trendMonths[0] : null
            },

            // Sonderfall OBI: projektübergreifende Wettbewerber-Sichtbarkeit nur für
            // das neue OBI-Projekt einblenden (fixe company_id + project_id).
            isObiProject() {
                const OBI = { company_id: "1547", project_id: "697744b926663e05c05d902f" }
                try {
                    const cid = this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    return cid === OBI.company_id && String(this.$route.params.id) === OBI.project_id
                } catch (e) {
                    return false
                }
            },
            searchTrendHeaderText() {
                return this.trendContextMonth ? `Search Trend @ ${this.trendContextMonth}` : "Search Trend"
            },
            allAvailableMonthsSorted() {
                const months = this.monthOptions.trendMonths.length
                    ? this.monthOptions.trendMonths.slice()
                    : Array.from(
                          new Set((this.categories || []).flatMap((c) => (Array.isArray(c.monthly_searches) ? c.monthly_searches : []).map((p) => this.fmtMonth(p.year, p.month))).filter(Boolean))
                      )
                return months.sort(this.sortMonthLabels)
            },
            monthColumnLabels() {
                const arr = this.allAvailableMonthsSorted
                // letzte 24 Monate
                return arr.slice(Math.max(arr.length - 24, 0))
            },
            // Header-Objekte für Monats-Spalten
            monthlyHeaders() {
                if (!this.showMonthlyColumns) return []
                return this.monthColumnLabels.map((label) => {
                    return {
                        label,
                        text: `GOOGLE SEARCHES ${label}`,
                        value: `ms_${label.replace("/", "_")}`,
                        align: "end",
                        width: "120px"
                    }
                })
            },
            availableLevels() {
                // zuerst Backend-Meta verwenden
                if (this.levelOptions && this.levelOptions.length) return this.levelOptions
                const set = new Set(this.categories.map((c) => c.level).filter((v) => v !== undefined && v !== null))
                return Array.from(set).sort((a, b) => a - b)
            },

            availableTrendMonths() {
                const src = this.monthOptions.trendMonths.length
                    ? this.monthOptions.trendMonths.slice()
                    : Array.from(
                          new Set((this.categories || []).flatMap((c) => (Array.isArray(c.monthly_searches) ? c.monthly_searches : []).map((p) => this.fmtMonth(p.year, p.month))).filter(Boolean))
                      )
                return src.sort(this.sortMonthLabels).reverse()
            },
            availablePeakMonths() {
                const src = this.monthOptions.peakMonths.length
                    ? this.monthOptions.peakMonths.slice()
                    : Array.from(
                          new Set((this.categories || []).flatMap((c) => (Array.isArray(c.monthly_searches) ? c.monthly_searches : []).map((p) => this.fmtMonth(p.year, p.month))).filter(Boolean))
                      )
                return src.sort(this.sortMonthLabels).reverse()
            },
            activeFilterCount() {
                return (this.filters.levels.length || 0) + (this.filters.trendMonths.length || 0) + (this.filters.peakMonths.length || 0)
            },
            test_set() {
                return (
                    process.env.VUE_APP_MONITORING_TEST_SET_COMPANY_ID !== this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8) &&
                    !!process.env.VUE_APP_MONITORING_TEST_SET_ID && process.env.VUE_APP_MONITORING_TEST_SET_ID == this.$route.params.id
                )
            },
            footerProps() {
                return {
                    itemsPerPageOptions: [10, 25, 50, 100],
                    showFirstLastPage: true
                }
            },
            headers() {
                const headerColumns = [
                    { text: "Category", value: "category", align: "start", width: "250px" },
                    { text: "Keyword Count", value: "keyword_count", tooltip: "The amount of keywords which are assigned to a category", align: "end", width: "170px" }
                ]
                headerColumns.push(
                    {
                        text: this.searchTrendHeaderText,
                        value: "search_trend",
                        tooltip:
                            "Indicates how the search volume has changed (dynamic trend basis). Based on moving average calculations. Average of the last two months compared to the average of the last 12 months.",
                        align: "end",
                        width: "200px"
                    },
                    {
                        text: "Peak Month",
                        value: "peakMonthLabel",
                        tooltip: "Month with highest search volume in the last 12 months.",
                        align: "end",
                        width: "150px"
                    },
                    {
                        id: 1,
                        text: this.monthRefLatest ? `Google Searches (${this.monthRefLatest})` : "Google Searches (Current Year-Month)",
                        value: "latestYearMonth",
                        tooltip: "Search volume of reference month.",
                        align: "end"
                    },
                    {
                        id: 2,
                        text: this.monthRefPrevYear ? `Google Searches (${this.monthRefPrevYear})` : "Google Searches (Previous Year-Month)",
                        value: "lastYearMonth",
                        tooltip: "Search volume of same month previous year (relative to reference).",
                        align: "end"
                    }
                )
                if (this.categories.some((c) => c.amazon_search_volume_total !== undefined)) {
                    headerColumns.push({
                        text: "Amazon Searches (Total)",
                        value: "amazon_search_volume_total",
                        tooltip: "Cumulative search volume on Amazon for all keywords in this category.",
                        align: "end"
                    })
                }
                // Internal Search Volume column hidden
                // if (this.categories.some((c) => Number(c.internal_search_volume_total) > 0)) {
                //     headerColumns.push({
                //         text: "Internal Search Volume",
                //         value: "internal_search_volume_total",
                //         tooltip:
                //             "Cumulative yearly internal search volume of all keywords in this category, incl. change vs. the previous import (previous year). Note: Internal search volume is not available for every keyword, so this value may be incomplete.",
                //         align: "end"
                //     })
                // }
                if (this.categories.some((c) => c.month_change_percent !== undefined)) {
                    headerColumns.push({
                        text: "Month Change (%)",
                        value: "month_change_percent",
                        tooltip: "Percentage change ref month vs same month prev year.",
                        align: "end"
                    })
                    if (this.categories.some((c) => c.month_change_abs !== undefined)) {
                        headerColumns.push({
                            text: "Month Change (Abs)",
                            value: "month_change_abs",
                            tooltip: "Absolute change ref month vs same month prev year.",
                            align: "end"
                        })
                    }
                }
                headerColumns.push(
                    {
                        text: this.monthRefCurrent12Range ? `Google Searches (${this.monthRefCurrent12Range})` : "Google Searches (Current 12 Months)",
                        value: "latest_12_month_search_volume",
                        tooltip: "Cumulative search volume of latest 12-month window relative to reference month.",
                        align: "end"
                    },
                    {
                        text: this.monthRefPrevious12Range ? `Google Searches (${this.monthRefPrevious12Range})` : "Google Searches (Previous 12 Months)",
                        value: "prev_12_month_search_volume",
                        tooltip: "Cumulative search volume of previous 12-month window before current window.",
                        align: "end"
                    }
                )
                if (this.categories.some((c) => c.year_change_percent !== undefined)) {
                    headerColumns.push({
                        text: "Year Change (%)",
                        value: "year_change_percent",
                        tooltip: "Percent change current 12M window vs previous 12M window.",
                        align: "end"
                    })
                    if (this.categories.some((c) => c.year_change_abs !== undefined)) {
                        headerColumns.push({
                            text: "Year Change (Abs)",
                            value: "year_change_abs",
                            tooltip: "Absolute change current 12M window vs previous 12M window.",
                            align: "end"
                        })
                    }
                }
                if (this.isObiProject && Array.isArray(this.selectedCompetitors) && this.selectedCompetitors.length) {
                    this.selectedCompetitors.forEach((c) => {
                        headerColumns.push({
                            text: c.domain,
                            value: `visibility_${c.domain}.value`,
                            tooltip:
                                this.monthRefLatest && this.monthRefPrevYear
                                    ? `Wettbewerber-Sichtbarkeit in dieser Kategorie: ${this.monthRefLatest} vs. ${this.monthRefPrevYear} (projekt\u00fcbergreifend zusammengef\u00fchrt).`
                                    : "Wettbewerber-Sichtbarkeit in dieser Kategorie: Fokusmonat vs. gleicher Monat im Vorjahr (projekt\u00fcbergreifend zusammengef\u00fchrt).",
                            align: "end",
                            width: "200px",
                            sortable: false
                        })
                    })
                }
                if (this.monthlyHeaders.length) headerColumns.push(...this.monthlyHeaders)
                headerColumns.push({ text: "", value: "actions", sortable: false, align: "end", width: 50 })
                return headerColumns
            }
            // return [
            //     { text: "Category", value: "category", tooltip: "", align: "start", width: "250px" },
            //     { text: "Keyword Count", value: "keyword_count", tooltip: "", align: "end" },
            //     ...this.selectedCompetitors.map((domain) => ({ text: domain.domain, value: `ranking_${domain.domain}`, align: "end" }))
            // ]
        },
        methods: {
            shiftMonthLabel(label, delta) {
                if (!label || typeof label !== "string" || !label.includes("/")) return null
                const [mStr, yStr] = label.split("/")
                let m = parseInt(mStr, 10)
                let y = parseInt(yStr, 10)
                if (isNaN(m) || isNaN(y)) return null

                let idx = y * 12 + (m - 1) + delta
                let newY = Math.floor(idx / 12)
                let newM = (((idx % 12) + 12) % 12) + 1
                const pad2 = (n) => (n < 10 ? "0" + n : "" + n)
                return `${pad2(newM)}/${newY}`
            },
            heatBgStyle(label, value) {
                if (!this.showMonthlyColumns || !this.showHeatmap) return {}
                if (value === null || value === undefined) {
                    return { background: "#f3f3f3", color: "#777" }
                }
                const s = this.monthStats[label]
                if (!s || s.min === null || s.max === null) {
                    return { background: "hsl(210, 20%, 90%)", color: "#333" }
                }
                if (s.max <= s.min) {
                    return { background: "hsl(210, 85%, 75%)", color: "#1a1a1a" }
                }
                const t = (value - s.min) / (s.max - s.min) // 0..1
                const lightness = 92 - t * 50 // 92% -> 42%
                const bg = `hsl(210, 85%, ${lightness}%)` // blaues Farbschema
                const fg = lightness < 55 ? "white" : "#1a1a1a"
                return { background: bg, color: fg, transition: "background-color .2s ease" }
            },
            createMonthlyHeader(label) {
                // label: "MM/YYYY"
                return {
                    label,
                    text: `GOOGLE SEARCHES ${label}`,
                    value: `ms_${label.replace("/", "_")}`,
                    align: "end",
                    width: "120px"
                }
            },
            computeShortTrendForMonth(item, refLabel) {
                if (!item || !Array.isArray(item.monthly_searches) || item.monthly_searches.length === 0) return null
                const arr = item.monthly_searches.slice().sort((a, b) => a.year - b.year || a.month - b.month)

                // Helper
                const pad2 = (n) => (n < 10 ? "0" + n : "" + n)
                const fmt = (y, m) => `${pad2(Number(m))}/${Number(y)}`
                const idxOf = (label) => arr.findIndex((p) => fmt(p.year, p.month) === label)

                // Referenzindex bestimmen
                let idx = arr.length - 1 // Default: letzter Monat
                if (refLabel) {
                    const found = idxOf(refLabel)
                    if (found !== -1) idx = found
                }

                // Für die Berechnung brauchen wir mindestens 14 Monate bis inkl. idx:
                // kurz: idx, idx-1; lang: idx-2 bis idx-13 (12 Monate)
                if (idx < 13) return null

                // Kurzfenster (2)
                const v0 = typeof arr[idx]?.volume === "number" ? arr[idx].volume : null
                const v1 = typeof arr[idx - 1]?.volume === "number" ? arr[idx - 1].volume : null
                if (v0 === null || v1 === null) return null
                const shortAvg = (v0 + v1) / 2

                // Langfenster (12, davorliegend)
                let sum = 0
                let cnt = 0
                for (let i = idx - 2; i >= idx - 13; i++) {
                    const v = typeof arr[i]?.volume === "number" ? arr[i].volume : null
                    if (v === null) return null
                    sum += v
                    cnt++
                }
                if (cnt !== 12) return null
                const longAvg = sum / 12

                if (longAvg === 0) return null
                const pct = ((shortAvg - longAvg) / longAvg) * 100
                return pct
            },

            // Re-Berechnung für alle Zeilen
            recomputeSearchTrendForAll() {
                const ref = this.filters.trendMonths.length === 1 ? this.filters.trendMonths[0] : null
                // Trend neu
                this.categories = this.categories.map((obj) => {
                    const dyn = this.computeShortTrendForMonth(obj, ref)
                    return {
                        ...obj,
                        search_trend: dyn !== null && dyn !== undefined ? dyn : obj.movingavg_short ?? null
                    }
                })
                // Monat-abhängige Metriken + Header
                this.recomputeMonthWindowMetrics(ref)
            },
            // Veränderung des internen Suchvolumens zum vorherigen Import (Vorjahr) in %.
            // null = keine Vergleichsbasis vorhanden.
            internalSvChangePercent(item) {
                const current = Number(item && item.internal_search_volume_total)
                const previous = Number(item && item.internal_search_volume_prev_total)
                if (!isFinite(current) || !isFinite(previous) || previous <= 0) return null
                return ((current - previous) / previous) * 100
            },
            getMonthlyVolume(item, label) {
                // label ist "MM/YYYY"
                if (!item || !Array.isArray(item.monthly_searches)) return null
                const [mStr, yStr] = label.split("/")
                const y = Number(yStr)
                const m = Number(mStr)
                const entry = item.monthly_searches.find((p) => Number(p.year) === y && Number(p.month) === m)
                if (!entry) return null
                const v = typeof entry.volume === "number" ? entry.volume : null
                return v
            },
            removeFilter(type, value) {
                if (!this.filters[type]) return
                this.filters[type] = this.filters[type].filter((v) => v !== value)
            },
            sortMonthLabels(a, b) {
                const [ma, ya] = a.split("/")
                const [mb, yb] = b.split("/")
                const da = new Date(parseInt(ya), parseInt(ma) - 1, 1)
                const db = new Date(parseInt(yb), parseInt(mb) - 1, 1)
                return da - db
            },
            buildFiltersPayload() {
                return {
                    levels: this.filters.levels,
                    trendMonths: [], //this.filters.trendMonths, // wieder ans Backend
                    peakMonths: this.filters.peakMonths
                }
            },
            fmtMonth(y, m) {
                if (y == null || m == null) return null
                const pad2 = (n) => (n < 10 ? "0" + n : "" + n)
                return `${pad2(Number(m))}/${Number(y)}`
            },
            computeTrendAndPeakFallback(obj) {
                const arr = Array.isArray(obj.monthly_searches) ? obj.monthly_searches.slice() : []
                if (!arr.length) {
                    obj.peakMonthLabel = obj.peakMonthLabel ?? null
                    obj.trendMonthLabel = obj.trendMonthLabel ?? null
                    return
                }
                arr.sort((a, b) => a.year - b.year || a.month - b.month)
                const pad2 = (n) => (n < 10 ? "0" + n : "" + n)
                const fmt = (y, m) => `${pad2(Number(m))}/${Number(y)}`
                // Peak
                let peak = null
                for (const p of arr) if (typeof p.volume === "number" && (!peak || p.volume > peak.volume)) peak = p
                if (!obj.peakMonthLabel) obj.peakMonthLabel = peak ? fmt(peak.year, peak.month) : null
                // Trend
                const startIdx = arr.length > 12 ? arr.length - 12 : 1
                let best = null
                for (let i = startIdx; i < arr.length; i++) {
                    const prev = arr[i - 1],
                        cur = arr[i]
                    if (typeof prev?.volume === "number" && typeof cur?.volume === "number") {
                        const delta = cur.volume - prev.volume
                        if (delta > 0 && (!best || delta > best.delta)) best = { delta, year: cur.year, month: cur.month }
                    }
                }
                if (!obj.trendMonthLabel) obj.trendMonthLabel = best ? fmt(best.year, best.month) : null
            },
            customSort(items, index, isDesc) {
                console.log(items[0])
                let sortedItems = this.$helpers.globalSort(items, index, isDesc, this.headers, { date: this.selectedDates[1], date_old: this.selectedDates[0] }, "monitoring_categories")
                console.log(sortedItems)
                return sortedItems
            },
            async fetchCategories(init = false) {
                try {
                    this.loading = true
                    const domainArray = this.selectedCompetitors.map((c) => c.domain)
                    const requestData = {
                        company_id: localStorage.company_id,
                        project_id: this.$route.params.id,
                        cat_level: "0",
                        domains: domainArray,
                        selectedDates: this.selectedDates,
                        filters: this.buildFiltersPayload(),
                        visibilityMode: this.isObiProject ? "yoy" : null,
                        // Bezugsmonat für den Sichtbarkeits-Vergleich (Fokusmonat vs. Vorjahresmonat)
                        visibilityFocusMonth: this.isObiProject ? this.monthRefLatest : null
                    }
                    if (this.category_id) {
                        let catParts = this.category_id.split(";")
                        requestData.cat_level = catParts.length.toString()
                        requestData.mother_cat = catParts[catParts.length - 1]
                        // voller Pfad der Mutter: gleichnamige Kategorien unter anderen Eltern nicht mitliefern
                        requestData.mother_cat_id = this.category_id
                    }
                    const url =
                        (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                            this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                        ) == -1
                            ? process.env.VUE_APP_MONITORING_API_URL
                            : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/get/categories/frontend"
                    const response = await this.$helpers.axiosPost(url, this.withTaxonomy(requestData))

                    // Meta übernehmen
                    this.monthOptions.trendMonths = response.data.meta?.availableTrendMonths || []
                    this.monthOptions.peakMonths = response.data.meta?.availablePeakMonths || []
                    this.levelOptions = response.data.meta?.availableLevels || []

                    this.categories = response.data.categories.map((c) => {
                        let obj = { ...c.category, competitorData: c.competitorData }
                        if (Array.isArray(obj.monthly_searches) && obj.monthly_searches.length >= 13) {
                            obj.latestYearMonth = obj.monthly_searches[obj.monthly_searches.length - 1].volume
                            obj.lastYearMonth = obj.monthly_searches[obj.monthly_searches.length - 13].volume
                            obj.month_change_abs = obj.latestYearMonth - obj.lastYearMonth
                            obj.year_change_abs = obj.latest_12_month_search_volume - obj.prev_12_month_search_volume
                        } else {
                            obj.latestYearMonth = null
                            obj.lastYearMonth = null
                        }
                        if (!obj.trendMonthLabel || !obj.peakMonthLabel) this.computeTrendAndPeakFallback(obj)
                        return obj
                    })
                    this.recomputeSearchTrendForAll()
                    this.count = response.data.count
                    // if (this.count === 0 && !init) this.$emit("bottomReached")
                    // this.setHeaderDateStrings()
                } catch (error) {
                    console.error(error)
                } finally {
                    this.loading = false
                }
            },
            // NEU: Hilfsfunktion für dynamische Monats-Metriken auf Basis Trend-Monat
            recomputeMonthWindowMetrics(refLabel) {
                const fmt = (y, m) => {
                    const pad2 = (n) => (n < 10 ? "0" + n : "" + n)
                    return `${pad2(Number(m))}/${Number(y)}`
                }

                this.categories = this.categories.map((cat) => {
                    const arr = Array.isArray(cat.monthly_searches) ? cat.monthly_searches.slice() : []
                    arr.sort((a, b) => a.year - b.year || a.month - b.month)

                    if (!arr.length) {
                        return {
                            ...cat,
                            latestYearMonth: null,
                            lastYearMonth: null,
                            month_change_abs: null,
                            month_change_percent: null,
                            peakMonthLabelTotal: null,
                            peakMonthLabel12m: null
                        }
                    }

                    // Referenz-Index (Trend-Monat oder letzter Monat)
                    let idx = arr.length - 1
                    if (refLabel) {
                        const found = arr.findIndex((p) => fmt(p.year, p.month) === refLabel)
                        if (found !== -1) idx = found
                    }

                    // 12-Monatsfenster relativ zu Referenz
                    const startIdx = Math.max(0, idx - 11)
                    const window12 = arr.slice(startIdx, idx + 1)

                    // Vorjahresmonat Index
                    const prevYearIdx = idx - 12
                    const latestVol = arr[idx] && typeof arr[idx].volume === "number" ? arr[idx].volume : null
                    const prevYearVol = prevYearIdx >= 0 && arr[prevYearIdx] && typeof arr[prevYearIdx].volume === "number" ? arr[prevYearIdx].volume : null

                    let monthAbs = null
                    let monthPct = null
                    if (latestVol !== null && prevYearVol !== null) {
                        monthAbs = latestVol - prevYearVol
                        if (prevYearVol !== 0) monthPct = ((latestVol - prevYearVol) / prevYearVol) * 100
                    }

                    const pad2 = (n) => (n < 10 ? "0" + n : "" + n)

                    // Peak über ALLE Monate (für Filter)
                    let peakTotal = null
                    for (const p of arr) {
                        if (typeof p.volume === "number" && (!peakTotal || p.volume > peakTotal.volume)) peakTotal = p
                    }
                    const peakMonthLabelTotal = peakTotal ? `${pad2(Number(peakTotal.month))}/${Number(peakTotal.year)}` : null

                    // Peak NUR im 12M-Fenster (für Anzeige)
                    let peak12m = null
                    for (const p of window12) {
                        if (typeof p.volume === "number" && (!peak12m || p.volume > peak12m.volume)) peak12m = p
                    }
                    const peakMonthLabel12m = peak12m ? `${pad2(Number(peak12m.month))}/${Number(peak12m.year)}` : null

                    return {
                        ...cat,
                        latestYearMonth: latestVol,
                        lastYearMonth: prevYearVol,
                        month_change_abs: monthAbs,
                        month_change_percent: monthPct,
                        peakMonthLabelTotal,
                        peakMonthLabel12m
                    }
                })
            },
            // PATCH: setHeaderDateStrings akzeptiert optional Trend-Label
            setHeaderDateStrings(refLabel) {
                if (!Array.isArray(this.categories) || this.categories.length === 0) return
                const first = this.categories[0]
                const ms = first && Array.isArray(first.monthly_searches) ? first.monthly_searches.slice() : null
                if (!ms || ms.length === 0) return

                ms.sort((a, b) => a.year - b.year || a.month - b.month)

                const pad2 = (n) => (n < 10 ? "0" + n : "" + n)
                // Falls refLabel vorhanden, daraus latest bestimmen, sonst letztes Element
                let latest = null
                if (refLabel) {
                    const m = ms.find((p) => `${pad2(p.month)}/${p.year}` === refLabel)
                    if (m) latest = { month: Number(m.month), year: Number(m.year) }
                }
                if (!latest) {
                    const last = ms[ms.length - 1]
                    latest = { month: Number(last.month), year: Number(last.year) }
                }

                const addMonths = (mObj, delta) => {
                    let y = mObj.year
                    let mm = mObj.month - 1
                    mm += delta
                    y += Math.floor(mm / 12)
                    mm = ((mm % 12) + 12) % 12
                    return { month: mm + 1, year: y }
                }

                const lastYearSameMonth = addMonths(latest, -12)
                const currStart = addMonths(latest, -11)
                const prevEnd = addMonths(latest, -12)
                const prevStart = addMonths(latest, -23)

                const latestYMHeader = this.headers.find((h) => h.id == 1)
                const lastYMHeader = this.headers.find((h) => h.id == 2)
                const current12Header = this.headers.find((h) => h.value === "latest_12_month_search_volume")
                const previous12Header = this.headers.find((h) => h.value === "prev_12_month_search_volume")

                if (latestYMHeader) {
                    latestYMHeader.text = `Google Searches ${pad2(latest.month)}/${latest.year}`
                }
                if (lastYMHeader) {
                    lastYMHeader.text = `Google Searches ${pad2(lastYearSameMonth.month)}/${lastYearSameMonth.year}`
                }
                if (current12Header) {
                    current12Header.text = `Google Searches ${pad2(currStart.month)}/${currStart.year} - ${pad2(latest.month)}/${latest.year}`
                }
                if (previous12Header) {
                    previous12Header.text = `Google Searches ${pad2(prevStart.month)}/${prevStart.year} - ${pad2(prevEnd.month)}/${prevEnd.year}`
                }
            },
            catCreated(newCat) {
                console.log("category created")
                this.showAddDialog = false
                let notifidata = {
                    label: "<h3>A new but empty category has been created!</h3><p>Now you can upload new or assign existing keywords from your Project</p> ",
                    icon: "mdi-check-circle-outline",
                    color: "primary",
                    type: "created-cat",
                    id: newCat.category_id
                }
                this.$emit("notify", notifidata)
                this.fetchCategories()
            },
            catDeleted() {
                console.log("category deleted")
                this.showDeleteDialog = false
                let notifidata = { label: "Category successfully deleted!", icon: "mdi-check-circle-outline", color: "primary" }
                this.$emit("notify", notifidata)
                this.fetchCategories()
            },
            setAddCategoryDialog(item) {
                console.log(this.category_id)
                if (item) {
                    this.presetParentId = ""
                    this.newCategory.parent = item
                    this.newCategory.name = ""
                } else {
                    if (this.category_id) {
                        this.presetParentId = this.category_id + ""
                    }
                    this.newCategory.parent = null
                    this.newCategory.name = ""
                }
                this.showAddDialog = true // statt showAddCategoryDialog
            },
            getCategoryLabel(item) {
                if (!item) return "-"
                // Direkt vorhandene Namensfelder prüfen
                const direct = item.name || item.category_name || item.label
                if (direct) return direct
                // Fallback: aus categories suchen
                const found = this.categories.find((c) => c.category_id === item.category_id)
                if (found) return found.name || found.category_name || found.label || found.category_id
                return item.category_id || "-"
            },

            // OPTIONAL: Wenn alter Aufruf getCatName beibehalten werden muss:
            getCatName(id) {
                const found = this.categories.find((c) => c.category_id === id)
                const value = found ? found.name || found.category_name || found.label || id : id
                return { value, id }
            },
            switchCat(item) {
                if (!item || !item.category_id) return
                this.$emit("switchCat", item.category_id, item._id, item)
            },
            // OBI-Sonderfall: Die Wettbewerber-Sichtbarkeit (Fokusmonat vs. gleicher
            // Monat im Vorjahr) wird bereits im Backend berechnet und projektübergreifend
            // zusammengeführt. Hier nur noch value/change/status durchreichen.
            getCompVisib(item, domain) {
                try {
                    const compData = (item.competitorData || []).find((entry) => entry.domain == domain)
                    if (!compData) return { value: 0, change: 0, status: null }
                    return {
                        value: compData.value != null ? compData.value : 0,
                        change: compData.change != null ? compData.change : 0,
                        status: compData.status || null
                    }
                } catch (error) {
                    console.log(error)
                    return { value: 0, change: 0, status: null }
                }
            }
        },
        watch: {
            // Beim Umschalten der Kategorisierung neu laden. Noetig auch dann, wenn
            // category_id unveraendert bleibt (Projektebene) und deshalb kein anderer Watcher feuert.
            taxonomyId() {
                this.fetchCategories()
            },
            filters: {
                deep: true,
                handler() {
                    this.fetchCategories()
                }
            },
            selectedCompetitors() {
                this.fetchCategories()
            },
            selectedDates() {
                this.fetchCategories()
            },
            category_id() {
                this.fetchCategories()
            },
            async exportData() {
                console.log("download triggered")
                // Header für Export vorbereiten:
                // - Basis: aktuelle Header
                // - Falls Monats-Spalten im UI deaktiviert sind, die letzten 12 Monats-Spalten trotzdem anhängen
                let headersForExport = this.headers.slice()
                const hasMonthlyCols = headersForExport.some((h) => typeof h.value === "string" && h.value.startsWith("ms_"))
                if (!hasMonthlyCols) {
                    const extraMonthly = this.monthColumnLabels.map((label) => this.createMonthlyHeader(label))
                    headersForExport = headersForExport.concat(extraMonthly)
                }

                // Kategorie-Pfad in einzelne Ebenen aufsplitten.
                // Der Kategorie-Name enthält die Hierarchie als ";"-getrennten String.
                // Da ";" auch das CSV-Trennzeichen ist, würde ein einzelner Wert die Spalten verschieben.
                // Deshalb den Pfad in eigene Spalten "Level 0" ... "Level x" aufteilen.
                const getCategoryLevels = (category) => {
                    const raw = this.getCatName(category.category_id).value
                    const parts = String(raw ?? "")
                        .split(";")
                        .map((s) => s.trim())
                    // Nachgestellte Leereinträge entfernen (z. B. wenn der Name auf ";" endet)
                    while (parts.length > 0 && parts[parts.length - 1] === "") parts.pop()
                    return parts
                }
                const maxLevels = this.categories.reduce((max, cat) => Math.max(max, getCategoryLevels(cat).length), 0)
                const levelFieldNames = Array.from({ length: Math.max(maxLevels, 1) }, (_, i) => `Level ${i}`)

                // Felder: die "Category"-Spalte durch die Level-Spalten ersetzen
                let fields = []
                headersForExport.forEach((header) => {
                    if (header.value === "category") {
                        fields.push(...levelFieldNames)
                    } else {
                        fields.push(header.text)
                    }
                })

                // Zeilen
                let rows = this.categories.map((category) => {
                    let row = {}
                    headersForExport.map((header) => {
                        const val = header.value
                        if (typeof val === "string" && val.substring(0, 11) == "visibility_") {
                            const compEntry = category.competitorData?.find((r) => r.domain == header.text)
                            row[header.text] = compEntry && compEntry.value != null ? compEntry.value : 0
                        } else if (val === "category") {
                            // Kategorie-Pfad auf die Level-Spalten verteilen
                            const levels = getCategoryLevels(category)
                            levelFieldNames.forEach((fieldName, i) => {
                                row[fieldName] = levels[i] ?? ""
                            })
                        } else if (typeof val === "string" && val.startsWith("ms_")) {
                            // Dynamische Monats-Spalte: aus monthly_searches ermitteln
                            // header.label enthält "MM/YYYY"
                            row[header.text] = this.getMonthlyVolume(category, header.label) ?? 0
                        } else {
                            row[header.text] = category[val]
                        }
                    })
                    return row
                })

                const post_data = {
                    rows,
                    fields,
                    fileTitle: `Categories_Trends_${(this.selectedDates[1] || this.selectedDates[0]).substring(0, 10)}`
                }

                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/export/csv"

                let response_data = await this.$helpers.axiosPost(url, post_data)
                window.location =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") +
                    "/" +
                    response_data.data
            }
        },
        mounted() {
            this.fetchCategories(true)
        }
    }
</script>

<style scoped>
    .row-pointer >>> tbody tr :hover {
        cursor: pointer;
    }
    .row-pointer table > thead > tr > th {
        white-space: nowrap !important;
    }
</style>
<style>
    #monitoringCatTable th {
        white-space: nowrap !important;
    }
    #monitoringCatTable table > tbody > tr > td:last-child {
        background: var(--v-keywordcol-base) !important;
        border-left: 2px solid var(--v-primary-base);
    }
    /* #monitoringCatTable table > thead > tr > th:last-child  */
    #monitoringCatTable table > tbody > tr > td:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0 !important;
    }
    #monitoringCatTable .qchip {
        background-color: rgb(250, 250, 250) !important;
        border-width: 1px;
    }
    #monitoringCatTable table > tbody > tr > td:nth-child(3),
    #monitoringCatTable table > thead > tr > th:nth-child(3) {
        /* background: #edeff1 !important; */
        border-left: 2px solid #edeff1;
        border-right: 2px solid #edeff1;
    }

    .theme--dark #monitoringCatTable .qchip {
        background-color: black !important;
        border-width: 1px;
    }
    #monitoringCatTable .internal-sv-change {
        display: inline-flex;
        align-items: center;
    }
    #monitoringCatTable .internal-sv-change__value,
    #monitoringCatTable .internal-sv-change__dash {
        font-size: 12px;
        line-height: 1;
        font-variant-numeric: tabular-nums;
        color: rgba(0, 0, 0, 0.72);
    }
    .theme--dark #monitoringCatTable .internal-sv-change__value,
    .theme--dark #monitoringCatTable .internal-sv-change__dash {
        color: rgba(255, 255, 255, 0.78);
    }
</style>
